document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  // Utility to wait for GSAP + any elements
  function waitForTargets(selector, callback) {
    if (typeof gsap === 'undefined') {
      return setTimeout(() => waitForTargets(selector, callback), 50);
    }

    const elements = document.querySelectorAll(selector);
    if (elements.length) {
      elements.forEach(el => callback(el));
    } else {
      setTimeout(() => waitForTargets(selector, callback), 50);
    }
  }

  // Animate each text wrapper independently
  waitForTargets(".landingPageTextWrapper", (el) => {
    gsap.set(el, { opacity: 0, y: 30 });

    gsap.to(el, {
      scrollTrigger: {
        trigger: el,
        toggleActions: "restart pause resume pause", // 
      },
      opacity: 1,
      y: 0,
      duration: 1.5,
      ease: "power2.out"
    });
  });

  // Animate each ribbon image independently
  waitForTargets(".ribbonImage", (el) => {
    gsap.set(el, { opacity: 0, scale: 0.85 });

    gsap.to(el, {
      scrollTrigger: {
        trigger: el,
        toggleActions: "restart pause resume pause",
      },
      opacity: 1,
      scale: 1,
      duration: 1.5,
      ease: "power2.out"
    });
  });
});
